export async function generateDeviceId() {
  // Gather device-specific attributes
  const fingerprintData = [
    navigator.userAgent, // Browser & OS info
    navigator.language, // Language settings
    // eslint-disable-next-line no-restricted-globals
    screen.width + "x" + screen.height, // Screen resolution
    new Date().getTimezoneOffset(), // Timezone
    navigator.hardwareConcurrency, // CPU cores
    getWebGLFingerprint(), // WebGL Fingerprint
    Date.now(), // Ensure uniqueness by adding current timestamp
    crypto.getRandomValues(new Uint32Array(1))[0], // Extra randomness
  ].join("|");

  // Hash the fingerprint data using SHA-256
  const hashedId = await hashFingerprint(fingerprintData);

  // Format the hash as a UUID
  return formatAsUUID(hashedId);
}

// Function to generate a WebGL fingerprint
function getWebGLFingerprint() {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (!gl) return "NoWebGL";
    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    return debugInfo
      ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      : "UnknownGPU";
  } catch (error) {
    return "ErrorWebGL";
  }
}

// Function to hash the fingerprint data using SHA-256
async function hashFingerprint(data) {
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

// Function to format a SHA-256 hash as a UUID
function formatAsUUID(hash) {
  return `${hash.substring(0, 8)}-${hash.substring(8, 12)}-${hash.substring(
    12,
    16
  )}-${hash.substring(16, 20)}-${hash.substring(20, 32)}`;
}
